import cond from 'ramda/src/cond';
import equals from 'ramda/src/equals';
import identity from 'ramda/src/identity';
import not from 'ramda/src/not';
import startsWith from 'ramda/src/startsWith';
import T from 'ramda/src/T';

var isSpecialCode = function isSpecialCode(value) {
  var twoSymbolCode = /8[1246]/.test(value.substring(0, 2));
  var threeSymbolCode = /8(5[2356]|7[0-4]|8[06])/.test(value.substring(0, 3));
  return twoSymbolCode || threeSymbolCode;
};

var replace10 = function replace10(val) {
  return val[0] === '9' ? "7".concat(val) : val;
};

var replace11 = function replace11(val) {
  return val[0] === '8' && not(isSpecialCode(val)) ? "7".concat(val.substring(1)) : val;
};

var replace13 = function replace13(value) {
  return cond([[startsWith('007'), function (str) {
    return str.substring(2);
  }], [function (str) {
    return startsWith('008', str) && not(isSpecialCode(str.substring(2)));
  }, function (str) {
    return "7".concat(str.substring(3));
  }], [T, identity]])(value);
};

var lengthIs = function lengthIs(val) {
  return function (str) {
    return equals(val, str.length);
  };
};

var replacePhoneCode = function replacePhoneCode(value) {
  return cond([[lengthIs(10), replace10], [lengthIs(11), replace11], [lengthIs(13), replace13], [T, identity]])(value);
};

export default replacePhoneCode;